import { render } from "./AddPrimaryStorage.vue?vue&type=template&id=3e957160&scoped=true"
import script from "./AddPrimaryStorage.vue?vue&type=script&lang=js"
export * from "./AddPrimaryStorage.vue?vue&type=script&lang=js"

import "./AddPrimaryStorage.vue?vue&type=style&index=0&id=3e957160&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e957160"]])

export default __exports__